import axios from 'axios'

// Set default baseURL to match Laravel's API routes prefix
axios.defaults.baseURL = '/api'

// Add a request interceptor to attach the auth token to all requests
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken') ||
            document.cookie.split('; ')
              .find(row => row.startsWith('accessToken='))
              ?.split('=')[1]

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    config.headers['Accept'] = 'application/json'
    
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

// Export plugin installer to be detected by plugin system
export default function(app) {
  // Make axios available throughout the app
  app.config.globalProperties.$axios = axios
}
